import { Button } from '@krp/ui-kit'

import { ResourcePickerScreen } from '../../resource-picker/ui/ResourcePickerScreen'
import type { ResourcePickerButton, ResourcePickerCopy } from '../../resource-picker/model/types'
import type { RmkSourcesActions, RmkSourcesVm } from '../model/types'

const COPY: ResourcePickerCopy = {
  title: 'Где будете работать?',
  sectionLabel: 'Источники для работы за кассой',
  loadingTitle: 'Ищем, где вы можете работать…',
  unavailableTitle: 'Не удалось узнать, какие источники вам доступны',
  emptyTitle: 'Кассовых источников нет',
  emptyText: 'Подключите кассу в «Источниках».',
  noAccessTitle: 'Вам пока не выдан доступ к кассам',
  noAccessText: 'Попросите администратора.',
  openLabel: 'Открыть',
}

/** Кнопки выбора источника РМК — каждая со своей записью реестра действий. */
function renderButton({ slot, label, variant, onClick }: ResourcePickerButton) {
  switch (slot) {
    case 'reload':
      return (
        <Button variant={variant} actionId="platform.rmk.reload" onClick={onClick}>
          {label}
        </Button>
      )
    case 'open':
      return (
        <Button variant={variant} actionId="platform.rmk.open-source" onClick={onClick}>
          {label}
        </Button>
      )
    case 'resources':
      return (
        <Button variant={variant} actionId="platform.rmk.sources" onClick={onClick}>
          {label}
        </Button>
      )
  }
}

/**
 * Раздел «РМК»: «Где будете работать?» (UI-RMK-FLOW 3.4). Выбор источника — универсальный `ResourcePickerScreen`;
 * здесь только слова РМК и записи реестра действий.
 */
export function RmkSourcesScreen({ vm, actions }: { vm: RmkSourcesVm; actions: RmkSourcesActions }) {
  return (
    <ResourcePickerScreen
      vm={vm}
      actions={actions}
      copy={COPY}
      renderButton={renderButton}
    />
  )
}
